import React from 'react';
import { Alert } from '@mui/material';
import { USER_IMPORT_STATUSES, useGetUserImportQuery } from '../../api/userImportsApi';

/**
 * A banner for a user import that's waiting to start (it runs in the background), or that
 * failed as a whole (its error). Nothing while it runs or once it finishes.
 */
export const UserImportStatusAlert = ({ importId }) => {
	const { data: userImport } = useGetUserImportQuery(importId);

	switch (userImport.status) {
		case USER_IMPORT_STATUSES.queued:
			return (
				<Alert severity='success'>
					File accepted. The import will start shortly and runs in the background, so you
					can leave this page.
				</Alert>
			);
		case USER_IMPORT_STATUSES.failed:
			return (
				<Alert severity='error'>
					{`The import failed: ${userImport.error} Rows done before it stopped are listed below; see the log for details.`}
				</Alert>
			);
		default:
			return null;
	}
};
